import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { TCAcceptIsValidatedGuard } from '../guards/tc-accept-validated-guard';
import { TcAcceptanceComponent } from './tc-acceptance.component';

@NgModule({
  declarations: [TcAcceptanceComponent],
  imports: [
    CommonModule,
    I18nModule,
    MatCheckboxModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoCheckboxParagraphComponent: {
          component: TcAcceptanceComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
          guards: [TCAcceptIsValidatedGuard],
        },
      },
    } as CmsConfig),
  ],
  exports: [TcAcceptanceComponent],
})
export class TcAcceptanceModule {}
